import { render, staticRenderFns } from "./GOODS_subpagehero.vue?vue&type=template&id=608772ba&"
import script from "./GOODS_subpagehero.vue?vue&type=script&lang=js&"
export * from "./GOODS_subpagehero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports